import React from 'react';

const About = () => {
  return (
    <section id="sobre" className="py-20 bg-light-gray">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/3">
            <img 
              src="/images/new/profile_photo_circular.png" 
              alt="Kelton Oliveira" 
              className="w-full h-auto mx-auto"
            />
          </div>
          
          <div className="lg:w-2/3">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 relative">
              Quem é Kelton Oliveira
              <span className="absolute bottom-0 left-0 w-24 h-1 bg-accent-red mt-2"></span>
            </h2>
            
            <p className="mb-4">
              Kelton Oliveira é Terapeuta, Palestrante, Pesquisador e Escritor.
            </p>
            
            <p className="mb-4">
              Sua missão é ajudar pessoas a romperem ciclos emocionais, libertarem-se de padrões inconscientes e reconstruírem suas identidades emocionais com autenticidade e liberdade.
            </p>
            
            <p className="mb-4">
              Com mais de 2 mil atendimentos terapêuticos realizados, Kelton conduz processos profundos de reconstrução emocional e fortalecimento psíquico, atuando de forma humanizada, ética e orientada para resultados duradouros.
            </p>
            
            <p className="mb-4">
              Lidera comunidades com mais de 4 mil membros ativos, onde oferece suporte contínuo, reflexões e ferramentas práticas para aqueles que buscam se libertar de relações e histórias emocionais disfuncionais.
            </p>
            
            <p className="mb-4">
              Sua atuação alcançou relevância internacional por meio de pesquisas científicas publicadas e citadas em periódicos de diversos países, consolidando seu nome também no campo acadêmico. Além disso, seus conteúdos digitais somam mais de 8 milhões de visualizações nas redes sociais, impactando uma audiência ampla e crescente.
            </p>
            
            <p className="mb-4">
              Como Escritor, desenvolve o livro Romper Ciclos e Construir Liberdade Emocional e uma segunda obra em produção, aprofundando ainda mais os fundamentos da reconstrução emocional e da identidade psíquica.
            </p>
            
            <p className="mb-4">
              Seu trabalho integra fundamentos da Psicanálise, Análise Comportamental e Programação Neurolinguística, em uma abordagem que transcende o tratamento convencional e propõe uma verdadeira jornada de transformação emocional.
            </p>
            
            <p className="mb-4 italic">
              "Proclamar liberdade às mentes cativas" não é apenas um lema: é a essência que sustenta cada palavra, cada atendimento e cada conteúdo que Kelton compartilha.
            </p>
            
            <p className="mb-4">
              Para aqueles que desejam mais do que um alívio temporário — para quem busca escrever uma nova história emocional —, seu trabalho oferece um caminho sólido e transformador.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
